import React, { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { TokenOutlined } from '@mui/icons-material';
import { PopupButton } from 'react-calendly';
import customUtils from 'utils/customUtils';
import { XCircle } from 'lucide-react';
import { MixpanelService } from 'utils/mixpanelService';

const UpgradeDialog = ({ visible, onClose, availableTokens }) => {
  useEffect(() => {
    if (visible) MixpanelService.track("upgrade_modal_opened", {});
  }, [visible]);

  const handleClose = () => {
    MixpanelService.track("upgrade_modal_closed", {});
    onClose();
  };
    let stripe_payment_link = null;
    if ((new Date()).getTimezoneOffset() == -330) {
        stripe_payment_link = "https://buy.stripe.com/fZe28OdyR7T31AA289";
    } else {
        stripe_payment_link = "https://buy.stripe.com/8x23cwdZTaiU3gr8Dm3ZK04";
    }

    return (
        <Dialog
            modal={false}
            draggable
            visible={visible}
            onHide={handleClose}
            content={({ hide }) => (
                <div
                    className="flex flex-column p-4 gap-4"
                    style={{
                        width: "45vw",
                        borderRadius: '6px',
                        background: "var(--background-primary)",
                        color: "var(--text-primary)",
                        border: "1px solid var(--borderColor)"
                    }}
                >
                    <div className='w-full'>
                        <div className="grid grid-cols-2 items-center gap-2">
                            <div>
                                <span className='!text-xl text-[var(--text-primary)]'>Upgrade</span>
                            </div>
                            <div className='flex justify-end'>
                                <Button
                                    type="button"
                                    icon={<XCircle size={16} className="text-[var(--text-primary)]" />}
                                    className="w-auto h-8 bg-transparent hover:bg-[var(--hover-bg)] border-none text-[var(--text-primary)] px-2 py-1 m-1 !rounded shadow-none transition-all duration-150"
                                    onClick={handleClose}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex flex-col justify-center'>
                        <div className='flex items-center mb-3'>
                            <span className='!text-2xl text-[var(--text-primary)]'>
                                <TokenOutlined /> Remaining AI Tokens:
                            </span>
                            <span className={`!text-2xl ml-2 ${availableTokens > 10000 ? "text-[var(--primary-color)]" : "text-red-400"}`}>
                                {availableTokens}
                            </span>
                        </div>
                        {availableTokens <= 10000 && (
                            <div className="text-center">
                                <span className='text-yellow-600 mt-2'>
                                    You're low on tokens! Upgrade now to unlock more AI power and keep building without limits.
                                </span>
                            </div>
                        )}
                    </div>
                    {/* Buttons */}
                    <div className="w-full flex justify-center gap-2">
                        <PopupButton
                            url={customUtils.calendlyDemoUrl}
                            rootElement={document.getElementById('root')}
                            text="Upgrade"
                            className="w-full flex items-center justify-center !rounded-lg border-none bg-[var(--primary-color)] hover:bg-[var(--primary-color-light)] text-white hover:bg-opacity-95 shadow-none py-2.5"
                        />
                        {/* <Button
                            className="w-full flex items-center justify-center !rounded-lg border-none bg-[var(--primary-color)] hover:bg-[var(--primary-color-light)] text-white hover:bg-opacity-95 shadow-none"
                            onClick={() => { window.open(stripe_payment_link, "_blank"); onClose() }}
                        >
                            <span>Upgrade</span>
                        </Button> */}
                    </div>
                    <div className="w-full flex gap-2 justify-center">
                        <span className="text-[var(--text-secondary)]">If you want to avail our Startup Plan,<PopupButton
                            url={customUtils.calendlyDemoUrl}
                            rootElement={document.getElementById('root')}
                            text="Book A Meeting Now!"
                            className="bg-transparent border-none shadow-none text-[var(--primary-color)] hover:text-[var(--primary-color-light)] uppercase"
                        /></span>
                    </div>
                </div>
            )}
        />
    );
};

export default UpgradeDialog;
